export default {
  namespaced: true,
  state: {
    selectedFilter: '',
  },
  getters: {
    getSelectedFilter(state) {
      return state.selectedFilter;
    },
  },
  mutations: {
    SET_SELECTED_FILTER(state, payload) {
      state.selectedFilter = payload;
    },
  },
  actions: {
    setSelectedFilter(context, payload) {
      context.commit('SET_SELECTED_FILTER', payload);
    },
  },
};
